import React from "react";
import { Box, Flex, SlideFade, Text } from "@chakra-ui/react";
import Layout from "components/Layout";
import Link from "components/Link";
import Image from "components/Image";
import image1 from "../../../public/people/1.jpg";
import image2 from "../../../public/people/2.jpg";
import image3 from "../../../public/people/3.jpg";
import ranaImage from "../../../public/people/rana.png";
import rajivImage from "../../../public/people/rajiv.png";
import teamImage from "../../../public/people/team.png";
import bgCircleTop from "../../../public/people/bg-circle-top.png";
import bgCircleCenter from "../../../public/people/bg-circle-center.png";
import bgCircleBottom from "../../../public/people/bg-circle-bottom.png";
import bgCircleJoinTeam from "../../../public/people/bg-circle-join-team.png";
import Head from "next/head";

const People: React.FC = () => {
  return (
    <Layout>
      <Head>
        <title>101Digital | Team</title>
      </Head>
      <SlideFade
        in={true}
        offsetY="50px"
        transition={{ enter: { duration: 1 } }}
      >
        <Text
          as="h1"
          textStyle="h1"
          textAlign={["center", null, null, null, null, "left"]}
          display="flex"
          flexDir={["column", null, null, null, null, "row"]}
          mt={["45px", null, null, null, null, "132px"]}
          mb={["13px", null, null, null, null, 8]}
        >
          <Text>The People &</Text>
          <Text color="secondary" ml={4}>
            The Vision
          </Text>
        </Text>
      </SlideFade>
      <Text
        textStyle="paragraphHighlighted"
        textAlign={["center", null, null, null, null, "left"]}
        px={["61px", null, null, null, null, 0]}
        fontWeight={300}
      >
        Our motivation for great digital products goes back to our
        founders&apos; story.
      </Text>

      <Box
        position="relative"
        width="100%"
        maxWidth="1152px"
        margin="0 auto"
        padding={[
          "46px 0 43px",
          null,
          null,
          null,
          null,
          "160px 16px 70px",
          "160px 0 70px",
          null,
          null,
          "160px 0 70px",
        ]}
      >
        <Box
          position="absolute"
          top="0"
          right="-384px"
          pointerEvents="none"
          zIndex={-1}
          display={["none", null, null, "block"]}
        >
          <Image src={bgCircleTop} alt="" />
        </Box>
        <Box
          position="absolute"
          top="35%"
          left="-384px"
          pointerEvents="none"
          zIndex={-1}
          display={["none", null, null, "block"]}
        >
          <Image src={bgCircleCenter} alt="" />
        </Box>
        <Box
          position="absolute"
          bottom="8%"
          right="-384px"
          pointerEvents="none"
          zIndex={-1}
          display={["none", null, null, "block"]}
        >
          <Image src={bgCircleBottom} alt="" />
        </Box>
        <Flex
          flexDir={["column", null, null, null, null, "row"]}
          align="center"
          w="100%"
          mb={["54.11px", null, null, null, null, "132px"]}
        >
          <SlideFade
            in={true}
            offsetX="-200px"
            transition={{ enter: { duration: 1 } }}
          >
            <Box flex={["0 0 100%", null, null, null, null, "52%"]}>
              <Image
                src={image1}
                alt="tech teams working together towards product delivery"
              />
            </Box>
          </SlideFade>
          <Flex flex={["0 0 100%", null, null, null, null, "48%"]}>
            <SlideFade
              in={true}
              offsetY="50px"
              transition={{ enter: { duration: 1 } }}
            >
              <Text
                textStyle="paragraph"
                p={[
                  "46px 61px 0px",
                  null,
                  null,
                  null,
                  null,
                  "0 16px 0px 32px",
                  null,
                  "0 0 0 86px",
                ]}
                textAlign={["center", null, null, null, null, "start"]}
                whiteSpace={["normal", null, null, null, null, "pre-line"]}
                fontSize={["14px", null, null, null, null, "21px"]}
                fontWeight="300"
              >
                Rana & Rajiv, our founders, have spent the last decade working
                with global banks and their digital transformation journeys. And
                they noticed the recurring challenge of delivering digital
                products.
              </Text>
            </SlideFade>
          </Flex>
        </Flex>

        <Flex
          align="center"
          w="100%"
          mb={["46.8px", null, null, null, null, "140px"]}
          flexDir={["column", null, null, null, null, "row-reverse"]}
        >
          <SlideFade
            in={true}
            offsetX="200px"
            transition={{ enter: { duration: 1 } }}
          >
            <Box flex={["0 0 100%", null, null, null, null, "52%"]}>
              <Image src={image2} alt="planning a quick product delivery" />
            </Box>
          </SlideFade>
          <Flex
            flex={["0 0 100%", null, null, null, null, "48%"]}
            justify="flex-end"
          >
            <SlideFade
              in={true}
              offsetY="50px"
              transition={{ enter: { duration: 1 } }}
            >
              <Text
                textStyle="paragraph"
                p={[
                  "46px 61px 0px",
                  null,
                  null,
                  null,
                  null,
                  "0 32px 0px 16px",
                  null,
                  "0 86px 0 0",
                ]}
                textAlign={["center", null, null, null, null, "start"]}
                whiteSpace={["normal", null, null, null, null, "pre-line"]}
                fontSize={["14px", null, null, null, null, "21px"]}
                fontWeight="300"
              >
                Banks and neo banks were struggling with getting products to
                market. Even with a clear vision and articulate strategy,
                product delivery and launch didn’t go to plan. Cost-intensive
                product creation and lack of technical expertise either delay or
                deter products from moving from concept to delivery.
              </Text>
            </SlideFade>
          </Flex>
        </Flex>

        <Flex
          flexDir={["column", null, null, null, null, "row"]}
          align="center"
          w="100%"
          mb={["98px", null, null, null, null, "196px"]}
        >
          <SlideFade
            in={true}
            offsetX="-200px"
            transition={{ enter: { duration: 1 } }}
          >
            <Box flex={["0 0 100%", null, null, null, null, "52%"]}>
              <Image src={image3} alt="launching products in shorter time" />
            </Box>
          </SlideFade>
          <Flex flex={["0 0 100%", null, null, null, null, "48%"]}>
            <SlideFade
              in={true}
              offsetY="50px"
              transition={{ enter: { duration: 1 } }}
            >
              <Text
                textStyle="paragraph"
                p={[
                  "46px 61px 0px",
                  null,
                  null,
                  null,
                  null,
                  "0 16px 0px 32px",
                  null,
                  "0 0 0 86px",
                ]}
                textAlign={["center", null, null, null, null, "start"]}
                whiteSpace={["normal", null, null, null, null, "pre-line"]}
                fontSize={["14px", null, null, null, null, "21px"]}
                fontWeight="300"
              >
                Rana and Rajiv created 101 Digital to simplify and accelerate
                the delivery of digital platforms. It is our mission to help
                businesses create phenomenal digital experiences. So every
                consumer, ourselves included, can enjoy them.
              </Text>
            </SlideFade>
          </Flex>
        </Flex>

        <Text
          as="h2"
          textStyle="h2"
          textAlign="center"
          fontSize={["18px", null, null, null, null, "48px"]}
          fontWeight="300"
          mb={["54px", null, null, null, null, "153px"]}
        >
          Founders
        </Text>

        <Flex
          flexDir={["column", null, null, null, null, "row"]}
          justify="center"
          w="100%"
          mb={["64px", null, null, null, null, "110px"]}
        >
          <Box
            position="relative"
            px={["24px", null, null, null, null, "0px"]}
            m={["auto", null, null, null, null, "0"]}
            textAlign={["center", null, null, null, "left"]}
          >
            <Image src={ranaImage} alt="101D" />
            <Link
              position="absolute"
              width="70px"
              height="70px"
              bottom={["7.5%", null, null, "39px"]}
              right={["13.5%", null, null, "38px"]}
              href="https://sg.linkedin.com/in/ranaperies"
              target="_blank"
              opacity={0}
              borderRadius="50%"
              onClick={() =>
                window.open("https://sg.linkedin.com/in/ranaperies", "_blank")
              }
            >
              {" "}
            </Link>
          </Box>
          <Flex>
            <Box>
              <Text
                textStyle="paragraph"
                ml={["0px", null, null, null, null, "104px"]}
                textAlign={["center", null, null, null, null, "start"]}
                whiteSpace={["normal", null, null, null, null, "pre-line"]}
                fontSize={["12px", null, null, null, null, "21px"]}
                fontWeight="300"
                p={["48px 29px 0px", null, null, null, null, "0px"]}
              >
                Rana is the CTO & co-founder of 101 Digital.
                {`\n`} Before founding 101 Digital, Rana was the
                {`\n`} Director, Innovation & Digital Services at
                {`\n`} Barclays Bank and the Head of Innovation
                {`\n`} and Digital Financial Services at the
                {`\n`} Commonwealth Bank of Australia.
              </Text>
              <Text
                textStyle="paragraph"
                ml={["0px", null, null, null, null, "104px"]}
                textAlign={["center", null, null, null, null, "start"]}
                whiteSpace={["normal", null, null, null, null, "pre-line"]}
                fontSize={["12px", null, null, null, null, "21px"]}
                fontWeight="300"
                p={["20px 29px 0px", null, null, null, null, "0px"]}
              >
                {`\n`} Rana has helped large regional and
                {`\n`} international financial services organizations
                {`\n`} shape new digital experiences. He has also
                {`\n`}
                worked with FinTechs to implement
                {`\n`} comprehensive open banking, digital
                {`\n`} banking, neobank, and embedded finance
                {`\n`} platforms for retail, corporate, SME and
                {`\n`} insurance businesses.
              </Text>
            </Box>
          </Flex>
        </Flex>

        <Flex
          flexDir={["column", null, null, null, null, "row-reverse"]}
          justify="center"
          w="100%"
          mb={["70px", 0]}
        >
          <Box
            position="relative"
            px={["24px", null, null, null, null, "0px"]}
            m={["auto", null, null, null, null, "0"]}
            textAlign={["center", null, null, null, "left"]}
          >
            <Image src={rajivImage} alt="101D" />
            <Link
              position="absolute"
              width="70px"
              height="70px"
              bottom={["7.5%", null, null, "39px"]}
              right={["13.5%", null, null, "38px"]}
              href="https://sg.linkedin.com/in/rajiv-ellepola-476b5b1"
              target="_blank"
              opacity={0}
              borderRadius="50%"
              onClick={() =>
                window.open(
                  "https://sg.linkedin.com/in/rajiv-ellepola-476b5b1",
                  "_blank"
                )
              }
            >
              {" "}
            </Link>
          </Box>
          <Flex>
            <Box>
              <Text
                textStyle="paragraph"
                mr={["0px", null, null, null, null, "104px"]}
                textAlign={["center", null, null, null, null, "start"]}
                whiteSpace={["normal", null, null, null, null, "pre-line"]}
                fontSize={["12px", null, null, null, null, "21px"]}
                fontWeight="300"
                p={["48px 29px 0px", null, null, null, null, "0px"]}
              >
                Rajiv is the co-founder and head of delivery
                {`\n`} and operations at 101 Digital. Before his role
                {`\n`} at 101 Digital, Rajiv was Director of Digital
                {`\n`} Platform & Experimentation for Barclays.
                {`\n`} Previously he held several leadership roles,
                {`\n`} including Head of Platform Delivery, Deputy
                {`\n`} CIO, Domain Lead Architect for
                {`\n`} Commonwealth Bank of Australia.
              </Text>
              <Text
                textStyle="paragraph"
                mr={["0px", null, null, null, null, "104px"]}
                textAlign={["center", null, null, null, null, "start"]}
                whiteSpace={["normal", null, null, null, null, "pre-line"]}
                fontSize={["12px", null, null, null, null, "21px"]}
                fontWeight="300"
                p={["20px 29px 0px", null, null, null, null, "0px"]}
              >
                {`\n`} Rajiv has led architecture, project office,
                {`\n`} development, and deployment teams to
                {`\n`} deliver complex digital solutions within large
                {`\n`} enterprises. He is passionate about
                {`\n`} implementing low-cost solutions to
                {`\n`} challenging problems through good design
                {`\n`} and smart engineering.
              </Text>
            </Box>
          </Flex>
        </Flex>
      </Box>

      <Flex
        position="relative"
        flexDir={["column-reverse", null, null, null, null, "row"]}
        justify="center"
        w="100%"
        px="16px"
      >
        <Box
          pos="absolute"
          top="-140px"
          left="0"
          display={["none", null, null, null, null, "block"]}
          zIndex="-1"
        >
          <Image src={bgCircleJoinTeam} alt="" />
        </Box>
        <Flex
          justify={["center", null, null, null, null, "flex-end"]}
          p={[
            "68px 64px 211.73px",
            null,
            null,
            null,
            null,
            "138px 132px 138px 0px",
          ]}
          w={["100%", null, null, null, null, "50%"]}
          bgImage={[
            "url('/circuit-board-white-small.png')",
            null,
            null,
            null,
            null,
            "none",
          ]}
        >
          <Image src={teamImage} alt="101D" />
        </Flex>
        <Flex
          w={["100%", null, null, null, null, "50%"]}
          bgImage="url('/circuit-board-white-small.png')"
          flexDir="column"
          justify="center"
          pt={["166px", null, null, null, null, "0px"]}
        >
          <Text
            as="h1"
            textStyle="h1"
            fontSize={["28.28px", null, null, null, null, "46px"]}
            lineHeight={["31.44px", null, null, null, null, "52px"]}
            mb={["31.45px", null, null, null, null, "50px"]}
            textAlign={["center", null, null, null, null, "start"]}
          >
            Join our team
          </Text>
          <Text
            textStyle="paragraph"
            mb={["50px", null, null, null, null, "44px"]}
            fontSize={["14px", null, null, null, null, "21px"]}
            fontWeight="300"
            whiteSpace={["normal", null, null, null, null, "pre-line"]}
            px={["68px", null, null, null, null, "0px"]}
            textAlign={["center", null, null, null, null, "start"]}
          >
            Work with a team that is fast paced, highly skilled
            {`\n`} and most importantly, looking out for each other.
          </Text>
          <Text
            as="h1"
            textStyle="h1"
            fontSize={["14px", null, null, null, null, "24px"]}
            lineHeight={["20px", null, null, null, null, "30px"]}
            textAlign={["center", null, null, null, null, "start"]}
            fontWeight={["400", null, null, null, null, "700"]}
            px={["88px", null, null, null, null, "0px"]}
          >
            Send your CV to recruitment@101digital.io
          </Text>
        </Flex>
      </Flex>
    </Layout>
  );
};

export default People;
